import { getAxiosClientWithToken } from './index';

export const getKisokuRegulation = () => {
    const restClient = getAxiosClientWithToken();
    return restClient.get(`/company/kisoku-regulations`);
};
